<template>
  <div class="block-wrap block-std-size-extends" style="padding-top: 8px">
    <div class="size-select-list">
      <label class="label"
        >选择参数(<span style="color: #f56c6c">{{ selectedNames.length }}</span> / {{ sizeMappings.length }}):</label
      >
      <el-checkbox-group v-model="selectedNames" class="checkbox-group">
        <template v-for="item in sizeMappings">
          <el-checkbox :key="item.name" :label="item.name"> {{ item.label }}</el-checkbox>
        </template>
      </el-checkbox-group>
    </div>
    <el-table height="300px" :key="tableRef" :data="list" v-on="$listeners">
      <el-table-column width="120px" fixed="left" key="sizeName" prop="sizeName" :label="stdSizeProp.name"> </el-table-column>
      <el-table-column v-for="col in tableCols" :key="col.prop" :prop="col.prop" v-bind="col.attrs">
        <template slot="header">
          <span v-if="col.required" style="color: red">*</span>
          {{ col.label }}
          <el-button v-if="!col.valueType" type="text" @click="switchValueType(col)" style="padding: 0">
            <i class="el-icon-swap"></i> {{ col.isRange ? '值' : '区间' }}
          </el-button>
        </template>
        <template slot-scope="{ row }">
          <template v-if="row.isShow">
            <el-form-item :inline-message="true" :error="row[`${col.prop}Error`]">
              <template v-if="col.isRange">
                <el-input-digit-range
                  v-model="row[`${col.prop}_range`]"
                  format="#.##"
                  clearable
                  v-bind="col.input.attrs"
                  @input="onInput(row, col.prop)"
                />
              </template>
              <el-input-digit
                v-else
                v-model.number="row[col.prop]"
                :nullable="true"
                v-bind="col.input.attrs"
                @input="onInput(row, col.prop)"
              />
            </el-form-item>
          </template>
        </template>
      </el-table-column>
      <el-table-column fixed="right" key="operate" prop="operate" label="操作">
        <template slot-scope="{ row }">
          <el-button type="text" @click="clearItem(row)">清空</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { genIsShowFn } from '../../../utils/disableRule';
import { cloneDeep, debounce } from 'lodash';

export default {
  components: {},
  props: {
    specifications: {
      type: Array,
      default() {
        return [];
      },
    },
    schema: {
      type: Object,
      default() {
        return {};
      },
    },
    importData: {
      type: [Array, Object],
      default() {
        return () => [];
      },
    }
  },
  data() {
    return {
      sizeMappings: [],
      selectedNames: [],
      list: [],
      originalList: [],
      tableCols: [],
      inputRules: {},
      stdSizeProp: {},
      valueMaps: {},
      tableRef: 0,
    };
  },
  inject: ['TmStep3'],
  watch: {
    schema: {
      handler(v) {
        this.initStdSizeExtends();
      },
      immediate: true,
    },
    specifications: {
      handler(v) {
        const stdSizeProp = this.specifications.find(item => item.nameKey.includes('std_size_prop_')) || {};
        const tm_std_size_extends = stdSizeProp?.extendValues?.tm_std_size_extends || [];
        this.selectedNames = tm_std_size_extends.filter(
          n => !this.sizeRequireMappings.find(size => size.name === n) && this.sizeMappings.find(size => size.name === n)
        );
        this.$set(this, 'stdSizeProp', stdSizeProp);
        this.$nextTick(() => {
          this.initList();
          this.tableCols.forEach(col => {
            if (col.isRange === undefined) {
              col.isRange = this.list.some(item => {
                return item[`${col.prop}_range`]?.start || item[`${col.prop}_range`]?.end;
              });
              if (col.valueType === 'onlyRange') {
                col.isRange = true;
              } else if (col.valueType === 'onlyValue') {
                col.isRange = false;
              }
            }
          });
        });
      },
      immediate: true,
      deep: true,
    },
    selectedNames: {
      handler(v) {
        this.updateTableCols();
      },
      immediate: true,
    },
    importData: {
      handler: debounce(function(v) {
        const sizeTitle = [...v.sizeTitle]
        sizeTitle.shift()
        const sizeTitleMap = {}
        /*
        *
        key: "袖长（cm）"
        value: {
          name: "size_mapping_xiuchang"
          rangeName: "size_mapping_xiuchang_range"
          rangeValue: {start: undefined, end: undefined}
          value: undefined
        }
        *
        * */
        let sizeMaps = [...this.sizeMappings].concat(this.sizeRequireMappings)
        // 针对非匹配S M L 的异性尺码进行清空初始化处理
        if (v.sizeMaps.hasOwnProperty('均码')) {
          sizeMaps = this.sizeRequireMappings
        };

        this.selectedNames = this.sizeMappings.reduce((selectedNames, item) => {
          if (sizeTitle.includes(item.label)) {
            selectedNames.push(item.name);
          }
          return selectedNames;
        }, []);
        sizeMaps.forEach(item => {
          if(sizeTitle.includes(item.label)) {
            sizeTitleMap[item.label] = {
              name: item.name,
              rangeName: `${item.name}_range`,
              value: undefined,
              rangeValue: {
                start: undefined,
                end: undefined
              }
            }
          }
        })
        const newSizeMaps = {}
        for(let key in v?.sizeMaps) {
          if (key === '均码') break;
          // key L,S,M
          for(let _key in sizeTitleMap) {
            const { name, rangeName, rangeValue } = sizeTitleMap[_key]
            // 针对模版中返回值为区间的，赋值给区间值
            let nameValue = v.sizeMaps[key][_key]
            let rangeValueShow = rangeValue
            if(v.sizeMaps[key][_key].includes('-')){
              nameValue = ''
              const { start,end } = this.parseRange(v.sizeMaps[key][_key])
              rangeValueShow = {
                start, 
                end,
              }
            }
            newSizeMaps[key] = {
              ...newSizeMaps[key],
              [name]: nameValue,
              [rangeName]: rangeValueShow
            }
          }

        }
        this.list = this.originalList
        // 针对非匹配S M L 的异性尺码进行清空初始化处理
        if (v.sizeMaps.hasOwnProperty('均码')) {
            this.list = this.list.map(item => {
              const processedItem = { ...item };
              // 遍历对象的所有键
              Object.keys(processedItem).forEach(key => {
                  // 使用正则表达式匹配以 size_mapping_ 开头且不以 _range 结尾的键
                  if (/^size_mapping_.*$/.test(key) && !/.*_range$/.test(key)) {
                      // 清空值
                      processedItem[key] = undefined;
                  }
              });
              return processedItem;
          });
          return;
        }
        // 普通情况下直接覆盖
        this.list = this.list.map(item => {
          // return {
          //   ...item,
          //   ...newSizeMaps[item.sizeName]
          // }
          // 解决模板导入数据为空问题
          return {
            isShow: item.isShow,
            sizeName: item.sizeName,
            sizeValue: item.sizeValue,
            ...newSizeMaps[item.sizeName]
          }
        })
      }, 100),
      immediate: false
    },
  },
  computed: {},
  methods: {
    initStdSizeExtends() {
      const sizeMappings = [];
      const sizeRequireMappings = [];
      if (this.schema) {
        const sizeExtendsChilds = this.schema.children || [];
        sizeExtendsChilds.forEach(item => {
          genIsShowFn(item);
          let itemName = item.name;
          const regexRange = /^size_mapping_[a-zA-Z0-9]+_range$/; // size_mapping_开头且_range结尾
          const regex = /^size_mapping_[a-zA-Z0-9](?!.*_range$).*$/; // size_mapping_开头且不以_range结尾
          if (regex.test(itemName) || regexRange.test(itemName)) {
            let newItem = null;
            if (regex.test(itemName)) {
              if (sizeExtendsChilds.find(i => i.name === itemName + '_range')) {
                newItem = { ...item };
              } else {
                newItem = { ...item, valueType: 'onlyValue' };
              }
            } else {
              itemName = itemName.replace('_range', '');
              if (sizeExtendsChilds.find(i => i.name === itemName)) {
                newItem = { ...item, name: itemName };
              } else {
                newItem = { ...item, name: itemName, valueType: 'onlyRange' };
              }
            }
            if (!sizeRequireMappings.concat(sizeMappings).find(s => s.name === itemName)) {
              if (item.rules?.requiredRule === 'true') {
                sizeRequireMappings.push(newItem);
              } else {
                sizeMappings.push(newItem);
              }
            }
          }
        });
      }
      this.sizeMappings = sizeMappings;
      this.sizeRequireMappings = sizeRequireMappings;
      this.updateTableCols();
    },
    updateTableCols() {
      const colList = [];
      const getItem = (item, extend) => {
        const oldItem = this.tableCols.find(old => old.prop === item.name) || {};
        const newItem = {
          prop: item.name,
          label: item.label,
          isShowFn: item.isShowFn,
          required: true,
          isRange: oldItem.isRange === undefined ? undefined : oldItem.isRange,
          valueType: item.valueType,
          attrs: {
            width: '160px',
          },
          input: {
            attrs: {
              width: '90%',
              precision: 2,
            },
            custom_validator: this._geninputRules(item.name, item.rules),
          },
          ...extend,
        };
        return newItem;
      };

      this.sizeRequireMappings.forEach(item => {
        colList.push(getItem(item));
      });
      this.selectedNames.forEach(name => {
        const requireItem = this.sizeRequireMappings.find(size => size.name === name);
        if (requireItem) return;
        const item = this.sizeMappings.find(size => size.name === name);
        item && colList.push(getItem(item, { required: false }));
      });
      this.$set(this, 'tableCols', colList);
      this.tableRef++
    },
    initList() {
      const list = [];
      if (!this.stdSizeProp?.name || !this.stdSizeProp.values?.length) {
        return [];
      }
      this.stdSizeProp.values.map(item => {
        if (item.value && item.checked) {
          const extendValues = item.extendValues || {};
          const tableItem = {
            sizeValue: item.value,
          };
          // 处理用于展示的规格值
          if (this.stdSizeProp.ui.type === 'SINGLECHECK') {
            // 此规格是下拉框类型的需要寻找options里对应的displayName
            tableItem.sizeName = this.stdSizeProp.ui.options.find(op => op.value === item.value)?.displayName || item.value || '未知';
          }
          this.tableCols.forEach(col => {
            const rangeKey = `${col.prop}_range`;
            const rangeValue = extendValues[rangeKey] || {};
            tableItem[col.prop] = tableItem[col.prop] || extendValues[col.prop];
            tableItem[rangeKey] = tableItem[rangeKey] || {
              start: rangeValue[`${col.prop}_from`],
              end: rangeValue[`${col.prop}_to`],
            };
            tableItem.isShow = col.isShowFn ? col.isShowFn({ [item.nameKey]: item.value }) : true;
          });
          list.push(tableItem);
        }
      });
      this.$set(this, 'list', list);

      this.originalList = cloneDeep(list)
    },
    method_getStdSizeData() {
      const data = {
        tm_std_size_extends: this.tableCols.map(col => col.prop),
      };
      this.list.forEach(item => {
        const sizeValue = item.sizeValue;
        data[sizeValue] = {};
        this.tableCols.forEach(col => {
          if (col.isRange) {
            data[sizeValue][`${col.prop}_range`] = {
              [`${col.prop}_from`]: item[`${col.prop}_range`].start,
              [`${col.prop}_to`]: item[`${col.prop}_range`].end,
            };
            delete data[sizeValue][`${col.prop}`];
          } else {
            data[sizeValue][col.prop] = item[col.prop];
            delete data[sizeValue][`${col.prop}_range`];
          }
        });
      });
      return data;
    },
    // 校验
    validateStdList() {
      // 校验空值
      const validateVoid = (value, prop) => {
        if (value === '' || value === undefined) {
          return `${prop.label}请勿输入空值`;
        }
        return false;
      };
      // 需要校验的props
      const props = this.tableCols.map(item => {
        let validator = item.input.validator || (item.required ? validateVoid : null);
        let newitem = {
          ...item,
          prop: item.prop,
          label: item.label,
          validator,
        };
        if (item.input.custom_validator) {
          delete newitem.validator;
          newitem.custom_validator = item.input.custom_validator;
        }
        return newitem;
      });
      let errmsg = '';
      for (let index = 0; index < this.list.length; index++) {
        const item = this.list[index];
        for (let pidex = 0; pidex < props.length; pidex++) {
          const prop = props[pidex];
          if(!item.isShow) continue
          if (prop.custom_validator) {
            const custom_pass = prop.custom_validator(item, prop.prop);
            if (!custom_pass) {
              errmsg = '请完善尺码表明细';
            }
          } else if (prop.validator) {
            errmsg = prop.validator(item[prop.prop], prop);
          }
        }
      }
      if (errmsg) {
        this.$message.error('请完善尺码表明细');
        return false;
      }
      return true;
    },
    clearItem(tableItem) {
      this.tableCols.forEach(col => {
        tableItem[col.prop] = '';
        tableItem[`${col.prop}_range`] = {
          start: '',
          end: '',
        };
      });
    },
    switchValueType(item) {
      item.isRange = !item.isRange;
    },
    _geninputRules(prop, rules) {
      const { maxValueRule, requiredRule, regexRule } = rules || {};

      const validator = row => {
        const checkValue = _value => {
          if (requiredRule === 'true') {
            if (!_value && _value !== 0) {
              row[`${prop}Error`] = `必填`;
              return false;
            }
          }

          if (regexRule) {
            let reg = new RegExp(`^${regexRule}$`);
            if (!reg.test(_value)) {
              row[`${prop}Error`] = `请填入正确的格式：${regexRule}`;
              return false;
            }
          }
          if (maxValueRule) {
            if (Number(_value) > Number(maxValueRule)) {
              row[`${prop}Error`] = `最大值：${maxValueRule}`;
              return false;
            }
          }
          row[`${prop}Error`] = '';
          return true;
        };
        const isRange = this.tableCols.find(col => col.prop === prop)?.isRange;

        if (isRange) {
          const { start, end } = row[`${prop}_range`] || {};
          return checkValue(start) && checkValue(end);
        } else {
          return checkValue(row[prop]);
        }
      };
      this.inputRules[prop] = validator;
      return validator;
    },
    onInput(row, field) {
      this.inputRules[field] && this.inputRules[field](row);
    },
    parseRange(str) {
      // 验证正则：允许整数/小数，支持前后空格 
      const pattern = /^\s*([+-]?\d+\.?\d*)\s*-\s*([+-]?\d+\.?\d*)\s*$/;
      
      const match = str.match(pattern);
      if (!match) {
        console.warn(`Invalid range format: ${str}`);
        return { start: null, end: null, error: 'Invalid format' };
      }
    
      return {
        start: parseFloat(match[1]),
        end: parseFloat(match[2]),
        precision: match[1].split('.')[1]?.length || 0 // 保留原始精度信息 
      };
    },
  },
  mounted() {},
  beforeDestroy() {
    this.originalList = null;
    this.inputRules = {};
  }
};
</script>

<style lang="scss" scoped>
.block-wrap {
  border: 1px solid #dcdfe6;
}
.block-std-size-extends {
  :deep(.pdd-cell .cell) {
    overflow: visible;
    padding: 5px;
  }
}
.size-select-list {
  display: flex;
  background: #f9f5f5;
  margin: 10px;
  padding: 10px;
  border-radius: 8px;
  .label {
    width: 120px;
    text-align: right;
  }
  .checkbox-group {
    padding: 0px 10px 10px;
    flex: 1;
  }
}
</style>